export function isAbsoluteURL(url: string) {
  return /^https?:\/\//i.test(url);
}
